// extracted by mini-css-extract-plugin
export default {"nav":"MobileNav_nav__-priZ","tab":"MobileNav_tab__PX9DH","tabActive":"MobileNav_tabActive__Pplnv","label":"MobileNav_label__ZqaD7"};